


















































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Inject, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { minValue, numeric, required } from "vuelidate/lib/validators";

import axios from "@/api/AuthAPI/auth-request-api";
import UploadPicture from "@/components/app/images/upload-picture.vue";
import UploadingVideoToServer from "@/components/app/images/uploading-video-to-server.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import LoadingButton from "@/components/buttons/loading-button.vue";
import AddCinemaCategoryForm from "./add-cinema-category-form.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import CinemaStaffForm from "./cinema-staff-form.vue";
import NoImage from "@/components/app/shared/image/no-image.vue";
import StandartCategoryName from "@/components/app/card/standart-category-name.vue";

import { VueEditor } from "vue2-editor";
import { multimedia, pics } from "@/config/host.config";
import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { IFilmCategory } from "@/@types/cinema/film-category";
import { ILocale } from "@/@types/locale";
import { IFilm } from "@/@types/cinema/films";

@Component({
  mixins: [validationMixin],
  validations: {
    name: { required },
    filmLength: { numeric, minValue: minValue(0) },
    year: { numeric, minValue: minValue(1895) },
    awards_win: { numeric, minValue: minValue(0) },
    awards_nomination: { numeric, minValue: minValue(0) },
  },
  components: {
    UploadingVideoToServer,
    submit: SubmitResetButtonGroop,
    AddCinemaCategoryForm,
    CinemaStaffForm,
    UploadPicture,
    LoadingButton,
    BSwitch,
    VueEditor,
    NoImage,
    StandartCategoryName,
  },
})
class ChangeFilmForm extends Vue {
  @Prop({ type: Object, default: null }) film!: IFilm;
  @Prop({ type: Array, default: () => [] }) categoryList!: IFilmCategory[];
  picsUrl = pics.cinema;

  @Inject({ from: "bgFolder", default: "cinema/bg" })
  readonly bgFolder!: string;
  @Inject({ from: "posterFolder", default: "cinema/poster" })
  readonly posterFolder!: string;

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  cinemaHost = pics.cinema;
  activeLocale = this.$store.getters.getLanguages[0];
  activeLogoLocale = this.$store.getters.getLanguages[0];
  show = false;
  sendFilmIDs = false;
  uri = multimedia.socket;

  kinopoiskId: number | null = null;
  imdbId: string | null = null;
  name = "";
  names: ILocale = {};
  nameOriginal: string | null = "";
  filmLength: number | null = null;
  slogan: string | null = "";
  description = "";
  descriptions: ILocale = {};
  shortDescription = "";
  shortDescriptions: ILocale = {};
  ratingMpaa: string | null = null;
  ratingAgeLimits: string | null = null;
  year: number | null = null;
  categorys: string[] = [];
  awards_win: number | null = null;
  awards_nomination: number | null = null;
  showFilm = true;
  directors: Array<ILocale> = [];
  actors: Array<ILocale> = [];
  // rating
  ratingKinopoisk: number | null = null;
  rottenTomatoes: string | null = null;
  filmAffinity: string | null = null;
  ratingImdb: number | null = null;
  metacritic: string | null = null;
  theMovieDb: string | null = null;
  tV_com: string | null = null;

  bg = "";
  poster = "";
  vertical_poster = "";
  posters: ILocale = {};
  vertical_posters: ILocale = {};
  logo = "";
  logos: ILocale = {};

  video_type: string | null = null;
  video: string | null = null;
  trailer: string | null = null;
  imDbGenrys: Array<ILocale> = [];
  kinopoiskGenrys: Array<ILocale> = [];
  videoFieldsOpen = false;

  @Watch("directors", { deep: true })
  dogWatchDirectors(): void {
    console.log(this.directors);
  }

  get bestImage(): { img: string; folder: string } | null {
    if (this.bg) {
      return { img: this.bg, folder: `${this.bgFolder}/fullhd` };
    }
    if (this.posters && this.posters[this.activeLocale]) {
      return {
        img: this.posters[this.activeLocale],
        folder: `${this.posterFolder}/${this.activeLocale}/origin`,
      };
    }
    if (this.vertical_posters && this.vertical_posters[this.activeLocale]) {
      return {
        img: this.vertical_posters[this.activeLocale],
        folder: `cinema/vertical_poster/${this.activeLocale}/origin`,
      };
    }
    return null;
  }

  get movie(): IFilm {
    return {
      _id: this.film ? this.film._id : "",
      kinopoiskId: this.kinopoiskId,
      imdbId: this.imdbId,
      name: this.names,
      nameOriginal: this.nameOriginal,
      filmLength: this.filmLength,
      slogan: this.slogan,
      description: this.descriptions,
      shortDescription: this.shortDescriptions,
      ratingMpaa: this.ratingMpaa,
      ratingAgeLimits: this.ratingAgeLimits,
      year: this.year,
      awards_win: this.awards_win,
      awards_nomination: this.awards_nomination,
      show: this.showFilm,
      categorys: this.categorys,
      staff: {
        directors: this.directors,
        actors: this.actors,
      },
      ratings: {
        ratingKinopoisk: this.ratingKinopoisk,
        rottenTomatoes: this.rottenTomatoes,
        filmAffinity: this.filmAffinity,
        ratingImdb: this.ratingImdb,
        metacritic: this.metacritic,
        theMovieDb: this.theMovieDb,
        tV_com: this.tV_com,
      },
      src: {
        bg: this.bg,
        poster: this.posters,
        vertical_poster: this.vertical_posters,
        logo: this.logos,
        video_type: this.video_type,
        video: this.video,
        trailer: this.trailer,
      },
      genres: {
        imDb: this.imDbGenrys,
        kinopoisk: this.kinopoiskGenrys,
      },
    };
  }

  addCategory(id: string): void {
    if (this.categorys.includes(id)) return;
    this.categorys.push(id);
  }

  @Watch("video")
  changeVideoType(): void {
    if (!this.video) return;
    const arrSplit = this.video.split(".");
    this.video_type = arrSplit[arrSplit.length - 1];
  }

  @Watch("name")
  addName(): void {
    this.names[this.activeLocale] = this.name;
  }

  @Watch("poster")
  addPoster(): void {
    this.posters[this.activeLocale] = this.poster;
  }

  @Watch("vertical_poster")
  addVerticalPoster(): void {
    this.vertical_posters[this.activeLocale] = this.vertical_poster;
  }

  @Watch("logo")
  addLogo(): void {
    this.logos[this.activeLocale] = this.logo;
  }

  @Watch("description")
  addDescription(): void {
    this.descriptions[this.activeLocale] = this.description;
  }

  @Watch("shortDescription")
  addShortDescription(): void {
    this.shortDescriptions[this.activeLocale] = this.shortDescription;
  }

  @Watch("activeLocale")
  changeLocale(): void {
    if (this.names)
      this.name = this.names[this.activeLocale]
        ? this.names[this.activeLocale]
        : "";
    else this.name = "";

    if (this.descriptions)
      this.description = this.descriptions[this.activeLocale]
        ? this.descriptions[this.activeLocale]
        : "";
    else this.description = "";

    if (this.shortDescriptions)
      this.shortDescription = this.shortDescriptions[this.activeLocale]
        ? this.shortDescriptions[this.activeLocale]
        : "";
    else this.shortDescription = "";

    if (this.posters)
      this.poster = this.posters[this.activeLocale]
        ? this.posters[this.activeLocale]
        : "";
    else this.poster = "";

    if (this.vertical_posters)
      this.vertical_poster = this.vertical_posters[this.activeLocale]
        ? this.vertical_posters[this.activeLocale]
        : "";
    else this.vertical_poster = "";

    if (this.logos)
      this.logo = this.logos[this.activeLocale]
        ? this.logos[this.activeLocale]
        : "";
    else this.logo = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      console.log(this.$v);
      return;
    }

    this.$emit("update", this.movie._id, this.movie);
  }

  async quickFillingMovie(): Promise<void> {
    this.sendFilmIDs = true;
    const selectedCategorys = this.clone(this.categorys);
    this.getFilmsMeta()
      .then((film: IFilm) => {
        this.createMovie(film);
        this.categorys = selectedCategorys;
        this.sendFilmIDs = false;
      })
      .catch((error: AxiosError) => {
        console.log(error);
        this.sendFilmIDs = false;
      });
  }

  async getFilmsMeta(): Promise<IFilm> {
    const uri = multimedia.meta;
    const config: AxiosRequestConfig = {
      params: {
        kinopoiskId: this.kinopoiskId,
        imdbId: this.imdbId,
      },
    };
    return new Promise<IFilm>((res, rej) => {
      axios
        .get(uri, config)
        .then((response: AxiosResponse) => {
          if (response.status === 200) {
            res(response.data);
          }
        })
        .catch((error: AxiosError) => {
          rej(error);
        });
    });
  }

  @Watch("film")
  createMovie(film: IFilm | null): void {
    if (!film) {
      this.show = true;
      return;
    }

    this.kinopoiskId = film.kinopoiskId;
    this.imdbId = film.imdbId;
    this.names = this.clone(film.name);
    this.nameOriginal = film.nameOriginal;
    this.filmLength = film.filmLength;
    this.slogan = film.slogan;
    this.descriptions = this.clone(film.description);
    this.shortDescriptions = this.clone(film.shortDescription);
    this.ratingMpaa = film.ratingMpaa;
    this.ratingAgeLimits = film.ratingAgeLimits;
    this.year = film.year;
    this.awards_win = film.awards_win;
    this.awards_nomination = film.awards_nomination;
    this.showFilm = film.show ? film.show : false;
    this.categorys =
      film.categorys && film.categorys.length ? this.clone(film.categorys) : [];
    this.actors = this.clone(film.staff ? film.staff.actors : []);
    this.directors = this.clone(film.staff ? film.staff.directors : []);
    this.ratingKinopoisk = film.ratings.ratingKinopoisk;
    this.rottenTomatoes = film.ratings.rottenTomatoes;
    this.filmAffinity = film.ratings.filmAffinity;
    this.ratingImdb = film.ratings.ratingImdb;
    this.metacritic = film.ratings.metacritic;
    this.theMovieDb = film.ratings.theMovieDb;
    this.tV_com = film.ratings.tV_com;
    this.bg = film.src.bg ? film.src.bg : "";
    this.posters =
      film.src && film.src.poster ? this.clone(film.src.poster) : {};
    this.vertical_posters = this.clone(film.src?.vertical_poster || {});
    this.logos = film.src && film.src.logo ? this.clone(film.src.logo) : {};
    this.video_type = film.src.video_type;
    this.video = film.src.video;
    this.trailer = film.src.trailer;
    this.kinopoiskGenrys = this.clone(
      film.genres ? film.genres.kinopoisk : [{}]
    );
    this.imDbGenrys = this.clone(film.genres ? film.genres.imDb : [{}]);
    this.changeLocale();
    this.show = true;
  }

  clone<T>(val: T): T {
    return val ? JSON.parse(JSON.stringify(val)) : val;
  }

  formatAgeLimit(val: string | null): string {
    if (!val) return "—";
    let clean = val.replace(/^age/i, "");
    if (/^\d+$/.test(clean)) clean += "+";
    return clean;
  }

  onReset(): void {
    this.kinopoiskId = null;
    this.imdbId = null;
    this.name = "";
    this.names = {};
    this.nameOriginal = "";
    this.filmLength = null;
    this.slogan = "";
    this.description = "";
    this.descriptions = {};
    this.shortDescription = "";
    this.shortDescriptions = {};
    this.ratingMpaa = null;
    this.ratingAgeLimits = null;
    this.year = null;
    this.awards_win = null;
    this.awards_nomination = null;
    this.showFilm = false;
    this.categorys = [];
    this.actors = [];
    this.directors = [];
    this.ratingKinopoisk = null;
    this.rottenTomatoes = null;
    this.filmAffinity = null;
    this.ratingImdb = null;
    this.metacritic = null;
    this.theMovieDb = null;
    this.tV_com = null;
    this.bg = "";
    this.poster = "";
    this.vertical_poster = "";
    this.logo = "";
    this.video_type = "";
    this.video = null;
    this.trailer = null;
    this.kinopoiskGenrys = [];
    this.imDbGenrys = [];
  }

  updateCategory(category: IFilmCategory | undefined): void {
    if (!category || !category._id) {
      this.$emit("updateCategory", undefined);
      return;
    }
    this.categorys.push(category._id);
    this.$emit("updateCategory", category);
  }

  mounted(): void {
    this.createMovie(this.film);
  }

  destroyed(): void {
    this.onReset();
  }
}
export default ChangeFilmForm;
